import * as actionTypes from "./constant";
import { put, takeEvery, call } from "redux-saga/effects";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { push } from "connected-react-router";

function* commonFunction(value) {
  const token = localStorage.getItem("userToken");
  try {
    const response = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: value.body ? value.body : null,
    });
    
    if (!response.ok) {
      if (response.status === 401) {
        yield localStorage.removeItem("userToken");
        yield localStorage.removeItem("role");
        yield localStorage.removeItem("userData");
        yield localStorage.removeItem("userFilters");
        yield localStorage.removeItem("partyFilters");
        yield put(push("/login"));
      }
      
      if(response.status === 400 && value.failAction === actionTypes.PARTY_EDITBYID_FAIL_ACTION) {
          yield toast.error("Invalid pincode. Failed to update");

      } else if (value.toastErrorMessage) {
        yield toast.error(value.toastErrorMessage);
      } 

      throw new Error(`HTTP error! status: ${response.status}`);
    } else {
      if (value.successAction === actionTypes.EXPORT_DATA_SUCCESS_ACTION) {
        const contentType = response.headers.get("Content-Type");

        if (
          contentType &&
          (contentType.includes("application/vnd.ms-excel") ||
            contentType.includes(
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ) ||
            contentType.includes("text/csv"))
        ) {
          const blobResponse = yield response.blob();
          if (blobResponse instanceof Blob) {
            return blobResponse; 
          }
        } else {
          if (value.toastMessage) {
            yield toast.success();
          }
        }
      } else  if (value.successAction === actionTypes.EXPORT_ALL_CUSTOMER_DATA_SUCCESS_ACTION) {
        const contentType = response.headers.get("Content-Type");

        if (
          contentType &&
          (contentType.includes("application/vnd.ms-excel") ||
            contentType.includes(
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ) ||
            contentType.includes("text/csv"))
        ) {
          const blobResponse = yield response.blob();
          if (blobResponse instanceof Blob) {
            return blobResponse; 
          }
        } else {
          if (value.toastMessage) {
            yield toast.success();
          }
        }} else {
        const resJSON = yield response.json();
        if(value.successAction === actionTypes.PARTY_EDITBYID_SUCCESS_ACTION) {
          yield put({
            type: `${value.successAction}`,
            payload: true,
          });
        }
        yield put({
          type: `${value.successAction}`,
          payload: resJSON,
        });

        if (value.extraAction) {
          yield put({
            type: `${value.extraAction}`,
            payload: resJSON,
          });
        }

        if (value.toastMessage) {
          yield toast.success(value.toastMessage);
        }

        return resJSON;
      }
    }
  } catch (error) {
  }
}

function* fetchcustomerList(value) {
  const role = localStorage.getItem("role");
  let stateItem = value?.value?.stateItem || "";
  let distVal = value?.value?.distVal || "";
  let searchItem = value?.value?.searchItem || "";
  let status = value?.value?.status || "";
  let allocated = value?.value?.allocated || "";
  let page = value?.value?.page || 1;
  let pincode = value?.value?.pincode|| "";
  let assignedTo = value?.value?.assignedTo ;  
  let circleName = value?.value?.circleName || "";
  let regionName = value?.value?.regionName || "";
  let isAttempted = value?.value?.isAttempted || "";
  let endPoint = "";
  if(isAttempted === "Attempted"){
     
    if(status && allocated){
      let statusValue = status === "Verified"? true: false;
      let allocateValue = allocated === "Allocated"? true: false;
      
          endPoint = `verification/dashboard/isAttempted?isAttempted=true&isVerified=${statusValue}&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}&isAllocated=${allocateValue}`;
    } else if(status) {
      let statusValue = status === "Verified"? true: false;

      endPoint = `verification/dashboard/isAttempted?isAttempted=true&isVerified=${statusValue}&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
    } else if(allocated){
      let allocateValue = allocated === "Allocated"? true: false;
      endPoint = `verification/dashboard/isAttempted?isAttempted=true&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}&isAllocated=${allocateValue}`;

    } else {        
      endPoint = `verification/dashboard/isAttempted?isAttempted=true&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
    }
      
   } else if(isAttempted === "Not Attempted"){
    if(status && allocated){
      let statusValue = status === "Verified"? true: false;
      let allocateValue = allocated === "Allocated"? true: false;
      
          endPoint = `verification/dashboard/isAttempted?isAttempted=false&isVerified=${statusValue}&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}&isAllocated=${allocateValue}`;
    } else if(status) {
      let statusValue = status === "Verified"? true: false;

      endPoint = `verification/dashboard/isAttempted?isAttempted=false&isVerified=${statusValue}&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
    } else if(allocated){
      let allocateValue = allocated === "Allocated"? true: false;
      endPoint = `verification/dashboard/isAttempted?isAttempted=false&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}&isAllocated=${allocateValue}`;

    } else {        
      endPoint = `verification/dashboard/isAttempted?isAttempted=false&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
    }
   } else if (role === "admin") {
    if (stateItem || isAttempted || distVal || searchItem || allocated || status || assignedTo || pincode || circleName || regionName) {
   
       if (allocated === "Allocated") {
          if(status === "Verified"){
            endPoint = `verification/allocated?isVerified=true&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
          } else if (status === "Not Verified") {                        
            endPoint = `verification/allocated?isVerified=false&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
          } else {
            endPoint = `verification/allocated?page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
          }

      } else if (allocated === "Unallocated") {
        if(status === "Verified"){
          endPoint = `verification/nonAllocated?isVerified=true&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
        } else if (status === "Not Verified") {
          endPoint = `verification/nonAllocated?isVerified=false&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
        } else {
        endPoint = `verification/nonAllocated?page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
        }
      } else if (status === "Verified") {
        endPoint = `verification/customersByName?isVerified=true&state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}&circleName=${circleName}&regionName=${regionName}`;
      } else if (status === "Not Verified") {
        endPoint = `verification/customersByName?isVerified=false&state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}&circleName=${circleName}&regionName=${regionName}`;
      } else {
        endPoint = `verification/customersByName?state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}&circleName=${circleName}&regionName=${regionName}`;
      }
    } else {
      endPoint = `verification/customersByName?page=${page}&limit=20`;
    }
  } else if(role === 'circleHead') {
    if (stateItem || distVal || searchItem || allocated || status || assignedTo || pincode || regionName) {
      if (allocated === "Allocated") {
        if(status === "Verified"){
          endPoint = `verification/allocation/circle?isVerified=true&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
        } else if (status === "Not Verified") {
          endPoint = `verification/allocation/circle?isVerified=false&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
        } else {
          endPoint = `verification/allocation/circle?page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
        }

      } else if (allocated === "Unallocated") {
          if(status === "Verified"){
            endPoint = `verification/nonAllocation/circle?isVerified=true&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
          } else if (status === "Not Verified") {
            endPoint = `verification/nonAllocation/circle?isVerified=false&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
          } else {
            endPoint = `verification/nonAllocation/circle?page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
          }
      } else if (status === "Verified") {
        endPoint = `verification/getCustomers/circle?isVerified=true&state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}&regionName=${regionName}`;
      } else if (status === "Not Verified") {
        endPoint = `verification/getCustomers/circle?isVerified=false&state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}&regionName=${regionName}`;
      } else {
        endPoint = `verification/getCustomers/circle?state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}&regionName=${regionName}`;
      }
    } else {
        endPoint = `verification/getCustomers/circle?page=${page}&limit=20`;
      }
    } else if(role === 'regionHead') {
      if (stateItem || distVal || searchItem || allocated || status || assignedTo || pincode) {
        if (allocated === "Allocated") {
          if(status === "Verified"){
            endPoint = `verification/allocation/region?isVerified=true&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
          } else if (status === "Not Verified") {
            endPoint = `verification/allocation/region?isVerified=false&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
          } else {
            endPoint = `verification/allocation/region?page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
          }
  
        } else if (allocated === "Unallocated") {
            if(status === "Verified"){
              endPoint = `verification/nonAllocation/region?isVerified=true&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
            } else if (status === "Not Verified") {
              endPoint = `verification/nonAllocation/region?isVerified=false&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
            } else {
              endPoint = `verification/nonAllocation/region?page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
            }
        } else if (status === "Verified") {
          endPoint = `verification/getCustomers/region?isVerified=true&state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}`;
        } else if (status === "Not Verified") {
          endPoint = `verification/getCustomers/region?isVerified=false&state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}`;
        } else {
          endPoint = `verification/getCustomers/region?state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}`;
        }
      } else {
          endPoint = `verification/getCustomers/region?page=${page}&limit=20`;
        }
    } else if(role === 'divisionHead') {
      if (stateItem || distVal || searchItem || allocated || status || assignedTo || pincode) {
        if (allocated === "Allocated") {
          if(status === "Verified"){
            endPoint = `verification/allocation/division?isVerified=true&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
          } else if (status === "Not Verified") {
            endPoint = `verification/allocation/division?isVerified=false&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
          } else {
            endPoint = `verification/allocation/division?page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
          }
  
        } else if (allocated === "Unallocated") {
            if(status === "Verified"){
              endPoint = `verification/nonAllocation/division?isVerified=true&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
            } else if (status === "Not Verified") {
              endPoint = `verification/nonAllocation/division?isVerified=false&page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
            } else {
              endPoint = `verification/nonAllocation/division?page=${page}&limit=20&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
            }
        } else if (status === "Verified") {
          endPoint = `verification/getCustomers/division?isVerified=true&state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}`;
        } else if (status === "Not Verified") {
          endPoint = `verification/getCustomers/division?isVerified=false&state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}`;
        } else {
          endPoint = `verification/getCustomers/division?state=${stateItem}&district=${distVal}&page=${page}&search=${searchItem}&limit=20&assignedTo=${assignedTo}&pin=${pincode}`;
        }
      } else {
          endPoint = `verification/getCustomers/division?page=${page}&limit=20`;
        }
    }
  try {
    let params = {
      page: page,
      api: `${appConfig.ip}/${endPoint}`,
      method: "GET",
      failAction: actionTypes.FETCH_CUSTOMERLIST_FAIL_ACTION,
      successAction: actionTypes.FETCH_CUSTOMERLIST_SUCCESS_ACTION,
    };
  yield call(commonFunction, params);
 
   
  } catch (error) {
  }
}

function* fetchCustomerReport(value) {
  const role = localStorage.getItem("role");
  let stateItem = value?.value?.stateItem || "";
  let distVal = value?.value?.distVal || "";
  let searchItem = value?.value?.searchItem || "";
  let status = value?.value?.status || "";
  let allocated = value?.value?.allocated || "";
  let pincode = value?.value?.pincode|| "";
  let assignedTo = value?.value?.assignedTo;
  let circleName = value?.value?.circleName || "";
  let regionName = value?.value?.regionName || "";
  let isAttempted = value?.value?.isAttempted || "";
  
  let endPoint = "";
  if(isAttempted === "Attempted"){
     
    if(status && allocated){
      let statusValue = status === "Verified"? true: false;
      let allocateValue = allocated === "Allocated"? true: false;
      
          endPoint = `verification/dashboard/isAttempted?isAttempted=true&isVerified=${statusValue}&&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}&isAllocated=${allocateValue}`;
    } else if(status) {
      let statusValue = status === "Verified"? true: false;

      endPoint = `verification/dashboard/isAttempted?isAttempted=true&isVerified=${statusValue}&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
    } else if(allocated){
      let allocateValue = allocated === "Allocated"? true: false;
      endPoint = `verification/dashboard/isAttempted?isAttempted=true&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}&isAllocated=${allocateValue}`;

    } else {        
      endPoint = `verification/dashboard/isAttempted?isAttempted=true&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
    }
      
   } else if(isAttempted === "Not Attempted"){
    if(status && allocated){
      let statusValue = status === "Verified"? true: false;
      let allocateValue = allocated === "Allocated"? true: false;
      
          endPoint = `verification/dashboard/isAttempted?isAttempted=false&isVerified=${statusValue}&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}&isAllocated=${allocateValue}`;
    } else if(status) {
      let statusValue = status === "Verified"? true: false;

      endPoint = `verification/dashboard/isAttempted?isAttempted=false&isVerified=${statusValue}&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
    } else if(allocated){
      let allocateValue = allocated === "Allocated"? true: false;
      endPoint = `verification/dashboard/isAttempted?isAttempted=false&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}&isAllocated=${allocateValue}`;

    } else {        
      endPoint = `verification/dashboard/isAttempted?isAttempted=false&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
    }
   } else if (role === "admin") {
    if (stateItem || distVal || searchItem || allocated || status || assignedTo || pincode || circleName || regionName) {
      if (allocated === "Allocated") {
          if(status === "Verified"){
            endPoint = `verification/allocated?isVerified=true&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
          } else if (status === "Not Verified") {            
            endPoint = `verification/allocated?isVerified=false&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
          } else {
            endPoint = `verification/allocated?state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
          }

      } else if (allocated === "Unallocated") {
        if(status === "Verified"){
          endPoint = `verification/nonAllocated?isVerified=true&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
        } else if (status === "Not Verified") {
          endPoint = `verification/nonAllocated?isVerified=false&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
        } else {
          endPoint = `verification/nonAllocated?state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&circleName=${circleName}&regionName=${regionName}`;
        }
      } else if (status === "Verified") {
        endPoint = `verification/customersByName?isVerified=true&state=${stateItem}&district=${distVal}&search=${searchItem}&assignedTo=${assignedTo}&pin=${pincode}&circleName=${circleName}&regionName=${regionName}`;
      } else if (status === "Not Verified") {
      endPoint = `verification/customersByName?isVerified=false&state=${stateItem}&district=${distVal}&search=${searchItem}&assignedTo=${assignedTo}&pin=${pincode}&circleName=${circleName}&regionName=${regionName}`;
      } else {
        endPoint = `verification/customersByName?state=${stateItem}&district=${distVal}&search=${searchItem}&assignedTo=${assignedTo}&pin=${pincode}&circleName=${circleName}&regionName=${regionName}`;
      }
    } else {
      endPoint = `verification/customersByName?`;
    }
  } else if(role === 'circleHead') {
    if (stateItem || distVal || searchItem || allocated || status || assignedTo || pincode || regionName) {
      if (allocated === "Allocated") {
        if(status === "Verified"){
          endPoint = `verification/allocation/circle?isVerified=true&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
        } else if (status === "Not Verified") {
          endPoint = `verification/allocation/circle?isVerified=false&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
        } else {
          endPoint = `verification/allocation/circle?&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
        }

      } else if (allocated === "Unallocated") {
          if(status === "Verified"){
        endPoint = `verification/nonAllocation/circle?isVerified=true&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
          } else if (status === "Not Verified") {
            endPoint = `verification/nonAllocation/circle?isVerified=false&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
          } else {
            endPoint = `verification/nonAllocation/circle?state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}&regionName=${regionName}`;
          }
      } else if (status === "Verified") {
        endPoint = `verification/getCustomers/circle?isVerified=true&state=${stateItem}&district=${distVal}&search=${searchItem}&assignedTo=${assignedTo}&pin=${pincode}&regionName=${regionName}`;
      } else if (status === "Not Verified") {
      endPoint = `verification/getCustomers/circle?isVerified=false&state=${stateItem}&district=${distVal}&search=${searchItem}&assignedTo=${assignedTo}&pin=${pincode}&regionName=${regionName}`;
      } else {
        endPoint = `verification/getCustomers/circle?state=${stateItem}&district=${distVal}&search=${searchItem}&assignedTo=${assignedTo}&pin=${pincode}&regionName=${regionName}`;
      }
    } else {
        endPoint = `verification/getCustomers/circle`;
      }
    } else if(role === 'regionHead') {
      if (stateItem || distVal || searchItem || allocated || status || assignedTo || pincode) {
        if (allocated === "Allocated") {
          if(status === "Verified"){
            endPoint = `verification/allocation/region?isVerified=true&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
          } else if (status === "Not Verified") {
            endPoint = `verification/allocation/region?isVerified=false&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
          } else {
            endPoint = `verification/allocation/region?state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
          }
  
        } else if (allocated === "Unallocated") {
            if(status === "Verified"){
              endPoint = `verification/nonAllocation/region?isVerified=true&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
            } else if (status === "Not Verified") {
              endPoint = `verification/nonAllocation/region?isVerified=false&state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
            } else {
              endPoint = `verification/nonAllocation/region?state=${stateItem}&district=${distVal}&search=${searchItem}&pin=${pincode}&assignedTo=${assignedTo}`;
            }
        } else if (status === "Verified") {
          endPoint = `verification/getCustomers/region?isVerified=true&state=${stateItem}&district=${distVal}&search=${searchItem}&assignedTo=${assignedTo}&pin=${pincode}`;
        } else if (status === "Not Verified") {
          endPoint = `verification/getCustomers/region?isVerified=false&state=${stateItem}&district=${distVal}&search=${searchItem}&assignedTo=${assignedTo}&pin=${pincode}`;
        } else {
          endPoint = `verification/getCustomers/region?state=${stateItem}&district=${distVal}&search=${searchItem}&assignedTo=${assignedTo}&pin=${pincode}`;
        }
      } else {
          endPoint = `verification/getCustomers/region`;
        }
    }

  try {
    let params = {
      api: `${appConfig.ip}/${endPoint}`,
      method: "GET",
      failAction: actionTypes.EXPORT_ALL_CUSTOMER_FAIL_ACTION,
      successAction: actionTypes.EXPORT_ALL_CUSTOMER_SUCCESS_ACTION,
    };
   yield call(commonFunction, params); 
   
  } catch (error) {
  }
}

function* changeStatus(value) {
  let data = {
    ...value.value,
    status:
      value.value.status === "draft"
        ? "publish"
        : "deleted"
        ? "draft"
        : "draft",
  };

  try {
    let params = {
      method: "PUT",
      successAction: actionTypes.CHANGE_STATUS_PROJECT_SUCCESS_ACTION,
      failAction: actionTypes.CHANGE_STATUS_PROJECT_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    yield call(commonFunction, params);
    yield toast.success("Status updated successfully", {
      autoClose: 3000,
    });
  } catch (err) {}
}

function* fetchState(value) {
  try {
    let page = (value.value && value.value.page);
    let limit = (value?.value?.limit && value?.value?.limit) || 100;
    let role = localStorage.getItem("role");
    let all = value?.value?.all;
    let url = "";
    if(all){
      if(page !== '') {
        url = `state?page=${page}&limit=${limit}`;
      } else {
        url = `state?page=1&limit=100`;
      }
    }else{
      if (role === "admin") {
        if(page !== '') {
          url = `state?page=${page}&limit=${limit}`;
        } else {
          url = `state?page=1&limit=100`;
        }
      } else {
        if(page !== '') {
          url = `current/state?page=${page}&limit=${limit}`;
        } else {
          url = `current/state?page=1&limit=100`;
        }
      }
    }
   

    let params = {
      page: page,
      api: `${appConfig.ip}/masterdata/${url}`,
      method: "GET",
      successAction: actionTypes.FETCH_STATE_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_STATE_FAIL_ACTION,
    };
    yield call(commonFunction, params);
  } catch (error) {}
}
function* fetchDistrict(value) {
  
  try {
    let page = (value.value && value.value.page) || 1;
    let searchVal =
      value && value.value && value.value.value ? value.value.value : "";
      let urls = "";
    if (searchVal !== '') {
      urls = `state=${searchVal}&page=${page}&limit=1000`;
    } else {
      urls = `page=${page}&limit=1000`;
    }

    let params = {
      page: page,
      api: `${appConfig.ip}/masterdata/district?${urls}`,
      method: "GET",
      successAction: actionTypes.FETCH_DISTRICT_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_DISTRICT_FAIL_ACTION,
    };
    yield call(commonFunction, params);
  } catch (error) {}
}

function* exportAllCustomer(value) {
  const {
    stateItem = "",
    distVal = "",
    searchItem = "",
    status = "",
    allocated = "",
    pincode = "",
    assignedTo = "",
    circleName = "",
    regionName = "",
    isAttempted = "",
    format= ""
  } = value?.value || {};

  const queryParams = new URLSearchParams();

  if (stateItem) queryParams.append("state", stateItem);
  if (distVal) queryParams.append("district", distVal);
  if (searchItem) queryParams.append("search", searchItem);
  if (pincode) queryParams.append("pin", pincode);
  if (assignedTo) queryParams.append("assignedTo", assignedTo);
  if (circleName) queryParams.append("circleName", circleName);
  if (regionName) queryParams.append("regionName", regionName);

  if (status === "Verified") queryParams.append("isVerified", true);
  else if (status === "Not Verified") queryParams.append("isVerified", false);

  if (allocated === "Allocated") queryParams.append("isAllocated", true);
  else if (allocated === "UnAllocated") queryParams.append("isAllocated", false);

  if (isAttempted === "Attempted") queryParams.append("isAttempted", true);
  else if (isAttempted === "Not Attempted") queryParams.append("isAttempted", false);

  queryParams.append("format", format);

  const endPoint = `verification/customers/export/v2?${queryParams.toString()}`;

try {
  const params = {
    api: `${appConfig.ip}/${endPoint}`,
    method: "POST",
    failAction: actionTypes.EXPORT_ALL_CUSTOMER_DATA_FAIL_ACTION,
    successAction: actionTypes.EXPORT_ALL_CUSTOMER_DATA_SUCCESS_ACTION,
  };
  const fileBlob = yield call(commonFunction, params);

  if (fileBlob instanceof Blob) {
    const url = window.URL.createObjectURL(fileBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = format === 'excel'? "Customer_Report.xlsx":"Customer_Report.csv"; 
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
} catch (error) {
  yield toast.success();
}
}

function* exportData(value) {
  const format = value?.value?.format || "csv";
  let customerList = value?.value?.customerList || [];

  // Remove duplicates
  customerList = [...new Set(customerList)];

  if (customerList.length === 0) {
    yield toast.error("No customers selected to export.");
    return;
  }

  const data = { customerId: customerList };
  const url = `/verification/customers/export?format=${format}`;

  const params = {
    api: `${appConfig.ip}${url}`,
    method: "POST",
    successAction: actionTypes.EXPORT_DATA_SUCCESS_ACTION,
    failAction: actionTypes.EXPORT_DATA_FAIL_ACTION,
    body: JSON.stringify(data),
    toastErrorMessage: "Failed to export data",
  };

  try {
    const blobResponse = yield call(commonFunction, params);

    if (blobResponse instanceof Blob) {
      const contentType = blobResponse.type;
      let fileExtension = "csv"; // default

      if (
        contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ||
        contentType.includes("application/vnd.ms-excel")
      ) {
        fileExtension = "xlsx";
      }

      const url = window.URL.createObjectURL(blobResponse);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Customer_Report_${Date.now()}.${fileExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      yield toast.success("Successfully exported data");
    } else {
      yield toast.error("Export failed. No file received.");
    }
  } catch (error) {
    yield toast.error("Export failed. Please try again.");
  }
}



function* importData(action) {
  const token = localStorage.getItem("userToken");
  const file = action.value.file;
  try {
    let urls = "/verification/customer/import";

    let formData = new FormData();
    formData.append("file", file);

    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const response = yield fetch(`${appConfig.ip}${urls}`, {
      method: "POST",
      headers: headers,
      body: formData,
    });

    if (response.status === 409) {
      yield toast.error(
        "File upload failed: A customer with the same name already exists."
      );
      throw new Error("File upload conflict");
    } else if (!response.ok) {
      yield toast.error("File upload failed");
      if (response.status === 401) {
        yield localStorage.removeItem("userToken");
        yield localStorage.removeItem("role");
        yield localStorage.removeItem("userData");
        yield localStorage.removeItem("userFilters");
        yield localStorage.removeItem("partyFilters");
        yield put(push("/login"));
      }
      yield toast.error(action.toastErrorMessage || "Failed to upload file.");
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const resJSON = yield response.json();
    yield put({
      type: actionTypes.IMPORT_DATA_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield toast.success(action.toastMessage || "File uploaded successfully.");
    return resJSON;
  } catch (error) {
    yield put({ type: actionTypes.IMPORT_DATA_FAIL_ACTION, error });
    yield toast.error("Failed to upload file");
  }
}

function* fetchPartyChangelogById(value) {
  let id = value?.value?.value;
   let  urls = `verification/customerUpdates/${id}`;
  try{
    let params = {
     api: `${appConfig.ip}/${urls}`,
      method: "GET",
      successAction: actionTypes.FETCH_PARTY_CHANGELOGBYID_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_PARTY_CHANGELOGBYID_FAIL_ACTION,
    };

   let res =  yield call(commonFunction, params)
   if(!res){
    yield put({
      type: actionTypes.FETCH_PARTY_CHANGELOGBYID_SUCCESS_ACTION,
      payload: [],
    });
   }

  } catch (e){

  }
}

function* PartyEditById(value) {
  let assignedTo = value && value.value.value?.assignedTo?
  value?.value?.value?.assignedTo:
    value?.value?.item.assignedTo;
  let assigneeName = value && value.value.value?.assignedName?
  value?.value?.value?.assignedName:
    value?.value?.item.assignedName;
  let pin = value && value.value.value?.pincode?
  value?.value?.value?.pincode:
  value?.value?.item?.pin;  
  let state = value && value.value.value?.state?
   value?.value?.value?.state :
   value?.value?.item.state;
  let district = value && value.value.value?.district?
   value?.value?.value?.district :
  value?.value?.item?.district;
  let id = value?.value?.item?._id;
  
  
  let  urls = `verification/customer/update/byUser/${id}`;
  let data = {
    pin:pin,
    state: state,
    district: district,
    assignedTo: assignedTo,
    assignedName: assigneeName
  }
 try{
   let params = {
    api: `${appConfig.ip}/${urls}`,
     method: "PATCH",
     successAction: actionTypes.PARTY_EDITBYID_SUCCESS_ACTION,
     failAction: actionTypes.PARTY_EDITBYID_FAIL_ACTION,
     body: JSON.stringify(data),
     toastMessage:"Succesfully updated",
     toastErrorMessage: "something went wrong, Failed to update"

   };

  yield call(commonFunction, params)
  
 return true;
 } catch (e){

 }
}

export function* MyCasesActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_CUSTOMERLIST_INIT_ACTION,
    fetchcustomerList
  );
  yield takeEvery(actionTypes.CHANGE_STATUS_PROJECT_INIT_ACTION, changeStatus);
  yield takeEvery(actionTypes.FETCH_STATE_INIT_ACTION, fetchState);
  yield takeEvery(actionTypes.FETCH_DISTRICT_INIT_ACTION, fetchDistrict);
  yield takeEvery(actionTypes.EXPORT_DATA_INIT_ACTION, exportData);
  yield takeEvery(actionTypes.IMPORT_DATA_INIT_ACTION, importData);
  yield takeEvery(actionTypes.EXPORT_ALL_CUSTOMER_INIT_ACTION, fetchCustomerReport);
  yield takeEvery(actionTypes.FETCH_PARTY_CHANGELOGBYID_INIT_ACTION, fetchPartyChangelogById);
  yield takeEvery(actionTypes.PARTY_EDITBYID_INIT_ACTION, PartyEditById);
  yield takeEvery(actionTypes.EXPORT_ALL_CUSTOMER_DATA_INIT_ACTION, exportAllCustomer);}
